import { useState } from 'react';
import { comicComments } from '@/mocks/comments';

export default function CommentsSection() {
  const [liked, setLiked] = useState<Set<string>>(new Set());

  const toggleLike = (id: string) => {
    setLiked((prev) => {
      const next = new Set(prev);
      if (next.has(id)) {
        next.delete(id);
      } else {
        next.add(id);
      }
      return next;
    });
  };

  return (
    <section aria-label="读者评论">
      <h2 className="mb-5 flex items-center gap-2.5 text-lg font-bold text-foreground-900 md:text-xl">
        <span className="h-5 w-1.5 rounded-full bg-primary-500" aria-hidden="true"></span>
        读者评论
        <span className="text-xs font-normal text-foreground-500">（{comicComments.length} 条精选）</span>
      </h2>
      <div className="flex flex-col gap-3">
        {comicComments.map((comment) => {
          const isLiked = liked.has(comment.id);
          return (
            <article key={comment.id} className="flex items-start gap-3 rounded-lg border border-background-200 bg-background-50 p-4">
              <span
                className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full ${comment.avatarColor} text-sm font-bold text-background-50`}
                aria-hidden="true"
              >
                {comment.nickname.slice(0, 1)}
              </span>
              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="text-sm font-bold text-foreground-900">{comment.nickname}</span>
                  <span className="text-xs text-foreground-400">{comment.time}</span>
                  <span className="flex items-center gap-1 rounded bg-secondary-100 px-1.5 py-0.5 text-[11px] text-secondary-900">
                    <i className="ri-verified-badge-fill h-3 w-3" aria-hidden="true"></i>
                    资深读者
                  </span>
                </div>
                <p className="mt-1.5 text-xs leading-6 text-foreground-700 md:text-sm">{comment.content}</p>
                <button
                  type="button"
                  onClick={() => toggleLike(comment.id)}
                  aria-pressed={isLiked}
                  className={`mt-2 flex items-center gap-1 rounded-full px-2.5 py-1 text-xs font-medium transition-colors ${
                    isLiked ? 'bg-primary-100 text-primary-600' : 'text-foreground-500 hover:bg-background-100 hover:text-primary-600'
                  }`}
                >
                  <i className={`${isLiked ? 'ri-thumb-up-fill' : 'ri-thumb-up-line'} h-4 w-4`} aria-hidden="true"></i>
                  {comment.likes + (isLiked ? 1 : 0)}
                </button>
              </div>
            </article>
          );
        })}
      </div>
      <div className="mt-4 flex items-center gap-2 rounded-lg border border-dashed border-background-300 bg-background-100/60 px-4 py-3 text-xs text-foreground-500">
        <i className="ri-chat-smile-3-line h-4 w-4 text-primary-500" aria-hidden="true"></i>
        登录后在虚拟漫画咖啡馆与更多读者交流阅读心得，分享你的追更感受～
      </div>
    </section>
  );
}